import {
    IMappingProfile,
    IQueryParams,
    IQueryParamsSymbol,
    PFWmsEntities,
} from '@pf/shared-common';
import { createMap, forMember, mapFrom, Mapper } from '@automapper/core';
import {
    entitySymbols,
    withDefaultEntityMetadata,
    withDefaultSearchParamsMetadata,
    withMetadata,
    withSearchFilter,
} from '@pf/shared-utility';
import {
    AsnLineCreate,
    AsnLineDto,
    AsnLineRead,
    AsnLineSearchParams,
} from '../../entities/asn-line.dto';
import { CustomFieldMetadataMap } from '@pf/shared/util-platform';

const symbols = entitySymbols(PFWmsEntities.AsnLine);

withDefaultEntityMetadata<AsnLineDto>(symbols.dto, {
    vendorLPN: String,
    vendorParentLPN: String,
    quantity: Number,
    containerType: Object,
    itemSerialNumber: String,
    purchaseOrderLineId: String,
    externalReferenceId: String,
    lineNumber: String,
    status: String,
    item: Object,
    reservedForLocation: Object,
    asnHeaderId: String,
    customFields: [CustomFieldMetadataMap.symbols.dto],
    weight: Object,
    dimensions: Object,
});

withDefaultEntityMetadata<AsnLineRead>(symbols.entity, {
    vendorLPN: String,
    vendorParentLPN: String,
    quantity: Number,
    containerType: Object,
    itemSerialNumber: String,
    purchaseOrderLineId: String,
    externalReferenceId: String,
    lineNumber: String,
    status: String,
    item: Object,
    reservedForLocation: Object,
    asnHeaderId: String,
    customFields: [CustomFieldMetadataMap.symbols.entity],
    weight: Object,
    dimensions: Object,
});

withMetadata<AsnLineCreate>(symbols.createBody, {
    vendorLPN: String,
    vendorParentLPN: String,
    quantity: Number,
    containerType: Object,
    itemSerialNumber: String,
    purchaseOrderLineId: String,
    externalReferenceId: String,
    lineNumber: String,
    status: String,
    itemId: String,
    asnHeaderId: String,
    weight: Object,
    dimensions: Object,
    locationId: String,
    purchaseOrderId: String,
});

withDefaultSearchParamsMetadata<AsnLineSearchParams>(symbols.searchParams, {
    asnHeaderId: String,
    externalReferenceId: String,
});

export const AsnLineMetadataMap: IMappingProfile = {
    symbols,
    profile: (mapper: Mapper) => {
        createMap<AsnLineRead, AsnLineDto>(mapper, symbols.entity, symbols.dto);
        createMap<AsnLineDto, AsnLineRead>(mapper, symbols.dto, symbols.entity);
        createMap<AsnLineDto, AsnLineCreate>(
            mapper,
            symbols.dto,
            symbols.createBody,
            forMember(
                d => d.locationId,
                mapFrom(s => s.reservedForLocation?.id)
            ),
            forMember(
                d => d.itemId,
                mapFrom(s => s.item?.id)
            )
        );
        createMap<IQueryParams<AsnLineDto>, AsnLineSearchParams>(
            mapper,
            IQueryParamsSymbol,
            symbols.searchParams,
            withSearchFilter('asnHeaderId'),
            withSearchFilter('externalReferenceId')
            // TODO not working because of required parentId
            // ...withDefaultSearchParamsMappingConfiguration()
        );
    },
};
